import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary';
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  variant = 'primary',
  href
}: CTAButtonProps) {
  const baseStyles = 'font-bold uppercase tracking-wide transition-all duration-300 flex items-center justify-center cursor-pointer no-underline';
  const variants = {
    primary: 'bg-cta-primary text-cta-text shadow-lg shadow-cta-primary/20 hover:shadow-cta-primary/50 rounded-xl px-8 py-4 text-lg',
    secondary: 'bg-transparent border-2 border-cta-primary text-cta-primary hover:bg-cta-primary/10 rounded-xl px-6 py-3 text-base'
  };
  const classes = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-280">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} onClick={onClick} data-id="element-281">
      {children}
    </motion.button>;
}